import { Component, OnInit } from '@angular/core';
import { LeaderboardCongratsPopupComponent } from '../leaderboard-congrats-popup/leaderboard-congrats-popup.component';
import { ModalController } from '@ionic/angular';
import { LeaderboardNicknamePopupPage } from '../leaderboard-nickname-popup/leaderboard-nickname-popup.page';
import { LeaderboardMyavataPopupPage } from '../leaderboard-myavata-popup/leaderboard-myavata-popup.page';
import { LeaderboardService } from 'src/app/services/leaderboard/leaderboard.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { Navigator } from 'src/app/components/menu/navigator';
import { AvatarService } from 'src/app/services/lobby/avatar.service';
import { isUndefined } from 'src/app/services/codeUtils';
import { CustomerModel } from 'src/app/models/customer-model';

@Component({
  selector: 'app-leaderboard',
  templateUrl: './leaderboard.component.html',
  styleUrls: ['./leaderboard.component.scss'],
})
export class LeaderboardComponent implements OnInit {

  items: any[] = new Array();
  timeRemaining;
  customerId: any;
  currentPlayer: any;
  customer: CustomerModel;

  
  playerAvatar: any;
  playerNotInLb: boolean = false;

  constructor(
    private modalController: ModalController,
    private leaderboardService:LeaderboardService,
    private userSession:UserSessionService,
    private utils:UtilsService,
    private navigator:Navigator,
    private avatarService:AvatarService
  ) {
    // this.openModal();
  }
  openAvatar(){

    this.navigator.navigateTo('AvatarComponent', { customModalClass: 'custom-modal-class-transparent', backdropDismiss: true })

  }
  ngOnInit() {
    this.getLeaderboardDetails();
   
   }

   getLeaderboardDetails(){
  
    this.items = [];
    this.leaderboardService.getActiveLeaderBoardDetails().subscribe(res => {
      if(!!res.result){
        if (res.result) {
          this.userSession.getCustomer().subscribe(
            (customer) => {
              this.customer = customer;
          
                this.customerId = customer.customerId;

            }
        );
          this.setTimeLeft(res.payload.timeRemaining);
        }
        if(!!res.payload.customerLeaderboards){
          for(let item of res.payload.customerLeaderboards){
            this.items.push(item);
            if(item.customerId === this.customerId){
              this.playerNotInLb = false;
              this.currentPlayer = item;
            }
          }
        }
          if(this.currentPlayer === null || isUndefined(this.currentPlayer)){
            this.playerNotInLb = true;
            // this.avatarService.getCustomerAvatar(this.customer.customerId).subscribe(response => {
            //   if(response.payload.avatar){
            //     this.playerAvatar  = response.payload;
            //     let currentRank 
            //     if(this.items.length){
            //       currentRank = this.items[this.items.length - 1].currentRank  + 1;
            //     }else {
            //       currentRank = 0;
            //     }
            //     this.currentPlayer = {
            //       "id": '',
            //       "points": 0,
            //       "avatar": this.playerAvatar.avatar,
            //       "nickName": this.customer.nickName || '',
            //       "currentRank": currentRank
            //   }; 
            //   }
            // })
            
          }
        
  
      }
    })
   }

  //  formatScore(score){
  //    if(Number(score) > 1000){
  //       return (Number(score)/1000).toFixed(1) + "K";
  //    }else {
  //      return score;
  //    }
  //  }

   formatScore(score){
    return score.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
   setTimeLeft(timeLeft: number) {
    if (timeLeft <= 0) {
      this.timeRemaining = timeLeft;
      return;
    } else {
      this.timeRemaining = timeLeft;
      if (timeLeft - 1000 >= 0) {
        setTimeout(() => this.setTimeLeft(timeLeft - 1000), 1000);
      }
    }
  }


  async onChangeAvatar() {
    const modal = await this.modalController.create({
      component: LeaderboardMyavataPopupPage,
      cssClass: 'fancy-modal'
    });
    return await modal.present();
  }

  onRefresh() {
    this.getLeaderboardDetails();
  }

  async onNicknameChangeClick() {
    console.log("changeNickName called")
    const modal = await this.modalController.create({
      component: LeaderboardNicknamePopupPage,
      cssClass: 'fancy-modal'
    });
    return await modal.present();
  }

  async openModal() {
    const modal = await this.modalController.create({
      component: LeaderboardCongratsPopupComponent,
      cssClass: 'fancy-modal'
    });
    return await modal.present();
  }
}
